import { Pipe, PipeTransform } from '@angular/core';
import { User } from "../../../../shared/models/user";

@Pipe({
    name: 'searchedUser',
    standalone: false
})
export class SearchedUserPipe implements PipeTransform {

  transform(items: searchUser[], searchText: string): any {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase().trim();
    return items.filter( item => {
      return item.userData.member.name.toLowerCase().includes(searchText.toLowerCase());
    });
  }
}
interface searchUser {
  userData: User,
  teamMember: boolean
}
